/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from "@tanstack/react-query";
import { useLctApIContext, LctApIContext } from "./lctApIContext";
import type * as Fetcher from "./lctApIFetcher";
import { lctApIFetch } from "./lctApIFetcher";
import type * as Schemas from "./lctApISchemas";

export type ApiAccountsUsersListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiAccountsUsersListError = Fetcher.ErrorWrapper<undefined>;

export type ApiAccountsUsersListVariables = {
  queryParams?: ApiAccountsUsersListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAccountsUsersList = (
  variables: ApiAccountsUsersListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedUserList,
    ApiAccountsUsersListError,
    undefined,
    {},
    ApiAccountsUsersListQueryParams,
    {}
  >({ url: "/api/accounts/users/", method: "get", ...variables, signal });

export const useApiAccountsUsersList = <TData = Schemas.PaginatedUserList,>(
  variables: ApiAccountsUsersListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedUserList,
      ApiAccountsUsersListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedUserList,
    ApiAccountsUsersListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/accounts/users/",
      operationId: "apiAccountsUsersList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiAccountsUsersList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiAccountsUsersRetrievePathParams = {
  id: number;
};

export type ApiAccountsUsersRetrieveError = Fetcher.ErrorWrapper<undefined>;

export type ApiAccountsUsersRetrieveVariables = {
  pathParams: ApiAccountsUsersRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAccountsUsersRetrieve = (
  variables: ApiAccountsUsersRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.User,
    ApiAccountsUsersRetrieveError,
    undefined,
    {},
    {},
    ApiAccountsUsersRetrievePathParams
  >({ url: "/api/accounts/users/{id}/", method: "get", ...variables, signal });

export const useApiAccountsUsersRetrieve = <TData = Schemas.User,>(
  variables: ApiAccountsUsersRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.User,
      ApiAccountsUsersRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.User,
    ApiAccountsUsersRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/accounts/users/{id}/",
      operationId: "apiAccountsUsersRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiAccountsUsersRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiAccountsUsersDestroyPathParams = {
  id: number;
};

export type ApiAccountsUsersDestroyError = Fetcher.ErrorWrapper<undefined>;

export type ApiAccountsUsersDestroyVariables = {
  pathParams: ApiAccountsUsersDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAccountsUsersDestroy = (
  variables: ApiAccountsUsersDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiAccountsUsersDestroyError,
    undefined,
    {},
    {},
    ApiAccountsUsersDestroyPathParams
  >({
    url: "/api/accounts/users/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiAccountsUsersDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiAccountsUsersDestroyError,
      ApiAccountsUsersDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiAccountsUsersDestroyError,
    ApiAccountsUsersDestroyVariables
  >({
    mutationFn: (variables: ApiAccountsUsersDestroyVariables) =>
      fetchApiAccountsUsersDestroy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiAccountsUsersProfileCreateCreatePathParams = {
  user: number;
};

export type ApiAccountsUsersProfileCreateCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAccountsUsersProfileCreateCreateVariables = {
  body?: Schemas.UserProfileRequest;
  pathParams: ApiAccountsUsersProfileCreateCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAccountsUsersProfileCreateCreate = (
  variables: ApiAccountsUsersProfileCreateCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserProfile,
    ApiAccountsUsersProfileCreateCreateError,
    Schemas.UserProfileRequest,
    {},
    {},
    ApiAccountsUsersProfileCreateCreatePathParams
  >({
    url: "/api/accounts/users/{user}/profile/create",
    method: "post",
    ...variables,
    signal,
  });

export const useApiAccountsUsersProfileCreateCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserProfile,
      ApiAccountsUsersProfileCreateCreateError,
      ApiAccountsUsersProfileCreateCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserProfile,
    ApiAccountsUsersProfileCreateCreateError,
    ApiAccountsUsersProfileCreateCreateVariables
  >({
    mutationFn: (variables: ApiAccountsUsersProfileCreateCreateVariables) =>
      fetchApiAccountsUsersProfileCreateCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiAccountsUsersProfileEditRetrievePathParams = {
  user: number;
};

export type ApiAccountsUsersProfileEditRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAccountsUsersProfileEditRetrieveVariables = {
  pathParams: ApiAccountsUsersProfileEditRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAccountsUsersProfileEditRetrieve = (
  variables: ApiAccountsUsersProfileEditRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserProfile,
    ApiAccountsUsersProfileEditRetrieveError,
    undefined,
    {},
    {},
    ApiAccountsUsersProfileEditRetrievePathParams
  >({
    url: "/api/accounts/users/{user}/profile/edit",
    method: "get",
    ...variables,
    signal,
  });

export const useApiAccountsUsersProfileEditRetrieve = <
  TData = Schemas.UserProfile,
>(
  variables: ApiAccountsUsersProfileEditRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserProfile,
      ApiAccountsUsersProfileEditRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.UserProfile,
    ApiAccountsUsersProfileEditRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/accounts/users/{user}/profile/edit",
      operationId: "apiAccountsUsersProfileEditRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiAccountsUsersProfileEditRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiAccountsUsersProfileEditUpdatePathParams = {
  user: number;
};

export type ApiAccountsUsersProfileEditUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAccountsUsersProfileEditUpdateVariables = {
  body?: Schemas.UserProfileRequest;
  pathParams: ApiAccountsUsersProfileEditUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAccountsUsersProfileEditUpdate = (
  variables: ApiAccountsUsersProfileEditUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserProfile,
    ApiAccountsUsersProfileEditUpdateError,
    Schemas.UserProfileRequest,
    {},
    {},
    ApiAccountsUsersProfileEditUpdatePathParams
  >({
    url: "/api/accounts/users/{user}/profile/edit",
    method: "put",
    ...variables,
    signal,
  });

export const useApiAccountsUsersProfileEditUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserProfile,
      ApiAccountsUsersProfileEditUpdateError,
      ApiAccountsUsersProfileEditUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserProfile,
    ApiAccountsUsersProfileEditUpdateError,
    ApiAccountsUsersProfileEditUpdateVariables
  >({
    mutationFn: (variables: ApiAccountsUsersProfileEditUpdateVariables) =>
      fetchApiAccountsUsersProfileEditUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiAccountsUsersProfileEditPartialUpdatePathParams = {
  user: number;
};

export type ApiAccountsUsersProfileEditPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAccountsUsersProfileEditPartialUpdateVariables = {
  body?: Schemas.PatchedUserProfileRequest;
  pathParams: ApiAccountsUsersProfileEditPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAccountsUsersProfileEditPartialUpdate = (
  variables: ApiAccountsUsersProfileEditPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserProfile,
    ApiAccountsUsersProfileEditPartialUpdateError,
    Schemas.PatchedUserProfileRequest,
    {},
    {},
    ApiAccountsUsersProfileEditPartialUpdatePathParams
  >({
    url: "/api/accounts/users/{user}/profile/edit",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiAccountsUsersProfileEditPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserProfile,
      ApiAccountsUsersProfileEditPartialUpdateError,
      ApiAccountsUsersProfileEditPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserProfile,
    ApiAccountsUsersProfileEditPartialUpdateError,
    ApiAccountsUsersProfileEditPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiAccountsUsersProfileEditPartialUpdateVariables,
    ) =>
      fetchApiAccountsUsersProfileEditPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiAllUserApplicationsListQueryParams = {
  /**
   * @format uuid
   */
  application?: string;
  /**
   * @format uuid
   */
  application__pvp?: string;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * A search term.
   */
  search?: string;
  /**
   * * `STARTED` - Started
   * * `PART_1_SUBMITTED` - Part 1 Submitted
   * * `PART_1_APPROVED` - Part 1 Approved
   * * `PART_2_SUBMITTED` - Part 2 Submitted
   * * `REJECTED` - Rejected
   * * `APPROVED` - Application Approved
   * * `FURTHER_INFO_PART_1` - Further Information Required (Part 1)
   * * `FURTHER_INFO_PART_2` - Further Information Required (Part 2)
   */
  status?:
    | "APPROVED"
    | "FURTHER_INFO_PART_1"
    | "FURTHER_INFO_PART_2"
    | "PART_1_APPROVED"
    | "PART_1_SUBMITTED"
    | "PART_2_SUBMITTED"
    | "REJECTED"
    | "STARTED";
  user?: number;
};

export type ApiAllUserApplicationsListError = Fetcher.ErrorWrapper<undefined>;

export type ApiAllUserApplicationsListVariables = {
  queryParams?: ApiAllUserApplicationsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiAllUserApplicationsList = (
  variables: ApiAllUserApplicationsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedDetailedApplicationList,
    ApiAllUserApplicationsListError,
    undefined,
    {},
    ApiAllUserApplicationsListQueryParams,
    {}
  >({
    url: "/api/all-user-applications/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiAllUserApplicationsList = <
  TData = Schemas.PaginatedDetailedApplicationList,
>(
  variables: ApiAllUserApplicationsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedDetailedApplicationList,
      ApiAllUserApplicationsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedDetailedApplicationList,
    ApiAllUserApplicationsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/all-user-applications/",
      operationId: "apiAllUserApplicationsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiAllUserApplicationsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiCarbonScoresListQueryParams = {
  /**
   * @format uuid
   */
  application?: string;
  /**
   * @format uuid
   */
  application__pvp?: string;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * A search term.
   */
  search?: string;
};

export type ApiCarbonScoresListError = Fetcher.ErrorWrapper<undefined>;

export type ApiCarbonScoresListVariables = {
  queryParams?: ApiCarbonScoresListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiCarbonScoresList = (
  variables: ApiCarbonScoresListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedCarbonScoreList,
    ApiCarbonScoresListError,
    undefined,
    {},
    ApiCarbonScoresListQueryParams,
    {}
  >({ url: "/api/carbon-scores/", method: "get", ...variables, signal });

export const useApiCarbonScoresList = <
  TData = Schemas.PaginatedCarbonScoreList,
>(
  variables: ApiCarbonScoresListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedCarbonScoreList,
      ApiCarbonScoresListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedCarbonScoreList,
    ApiCarbonScoresListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/carbon-scores/",
      operationId: "apiCarbonScoresList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiCarbonScoresList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiIntegrationsCarbonCalculatorPathwaysListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiIntegrationsCarbonCalculatorPathwaysListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorPathwaysListVariables = {
  queryParams?: ApiIntegrationsCarbonCalculatorPathwaysListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorPathwaysList = (
  variables: ApiIntegrationsCarbonCalculatorPathwaysListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedCarbonCalculatorPathwayList,
    ApiIntegrationsCarbonCalculatorPathwaysListError,
    undefined,
    {},
    ApiIntegrationsCarbonCalculatorPathwaysListQueryParams,
    {}
  >({
    url: "/api/integrations/carbon-calculator/pathways/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorPathwaysList = <
  TData = Schemas.PaginatedCarbonCalculatorPathwayList,
>(
  variables: ApiIntegrationsCarbonCalculatorPathwaysListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedCarbonCalculatorPathwayList,
      ApiIntegrationsCarbonCalculatorPathwaysListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedCarbonCalculatorPathwayList,
    ApiIntegrationsCarbonCalculatorPathwaysListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/integrations/carbon-calculator/pathways/",
      operationId: "apiIntegrationsCarbonCalculatorPathwaysList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiIntegrationsCarbonCalculatorPathwaysList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiIntegrationsCarbonCalculatorPathwaysCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorPathwaysCreateVariables = {
  body: Schemas.CarbonCalculatorPathwayRequest;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorPathwaysCreate = (
  variables: ApiIntegrationsCarbonCalculatorPathwaysCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysCreateError,
    Schemas.CarbonCalculatorPathwayRequest,
    {},
    {},
    {}
  >({
    url: "/api/integrations/carbon-calculator/pathways/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorPathwaysCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorPathway,
      ApiIntegrationsCarbonCalculatorPathwaysCreateError,
      ApiIntegrationsCarbonCalculatorPathwaysCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysCreateError,
    ApiIntegrationsCarbonCalculatorPathwaysCreateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorPathwaysCreateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorPathwaysCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorPathwaysRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorPathwaysRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorPathwaysRetrieveVariables = {
  pathParams: ApiIntegrationsCarbonCalculatorPathwaysRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorPathwaysRetrieve = (
  variables: ApiIntegrationsCarbonCalculatorPathwaysRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysRetrieveError,
    undefined,
    {},
    {},
    ApiIntegrationsCarbonCalculatorPathwaysRetrievePathParams
  >({
    url: "/api/integrations/carbon-calculator/pathways/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorPathwaysRetrieve = <
  TData = Schemas.CarbonCalculatorPathway,
>(
  variables: ApiIntegrationsCarbonCalculatorPathwaysRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CarbonCalculatorPathway,
      ApiIntegrationsCarbonCalculatorPathwaysRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/integrations/carbon-calculator/pathways/{id}/",
      operationId: "apiIntegrationsCarbonCalculatorPathwaysRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiIntegrationsCarbonCalculatorPathwaysRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiIntegrationsCarbonCalculatorPathwaysUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorPathwaysUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorPathwaysUpdateVariables = {
  body: Schemas.CarbonCalculatorPathwayRequest;
  pathParams: ApiIntegrationsCarbonCalculatorPathwaysUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorPathwaysUpdate = (
  variables: ApiIntegrationsCarbonCalculatorPathwaysUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysUpdateError,
    Schemas.CarbonCalculatorPathwayRequest,
    {},
    {},
    ApiIntegrationsCarbonCalculatorPathwaysUpdatePathParams
  >({
    url: "/api/integrations/carbon-calculator/pathways/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorPathwaysUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorPathway,
      ApiIntegrationsCarbonCalculatorPathwaysUpdateError,
      ApiIntegrationsCarbonCalculatorPathwaysUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysUpdateError,
    ApiIntegrationsCarbonCalculatorPathwaysUpdateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorPathwaysUpdateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorPathwaysUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorPathwaysPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateVariables = {
  body?: Schemas.PatchedCarbonCalculatorPathwayRequest;
  pathParams: ApiIntegrationsCarbonCalculatorPathwaysPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorPathwaysPartialUpdate = (
  variables: ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateError,
    Schemas.PatchedCarbonCalculatorPathwayRequest,
    {},
    {},
    ApiIntegrationsCarbonCalculatorPathwaysPartialUpdatePathParams
  >({
    url: "/api/integrations/carbon-calculator/pathways/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorPathwaysPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorPathway,
      ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateError,
      ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorPathway,
    ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateError,
    ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorPathwaysPartialUpdateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorPathwaysPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorPathwaysDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorPathwaysDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorPathwaysDestroyVariables = {
  pathParams: ApiIntegrationsCarbonCalculatorPathwaysDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorPathwaysDestroy = (
  variables: ApiIntegrationsCarbonCalculatorPathwaysDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiIntegrationsCarbonCalculatorPathwaysDestroyError,
    undefined,
    {},
    {},
    ApiIntegrationsCarbonCalculatorPathwaysDestroyPathParams
  >({
    url: "/api/integrations/carbon-calculator/pathways/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorPathwaysDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiIntegrationsCarbonCalculatorPathwaysDestroyError,
      ApiIntegrationsCarbonCalculatorPathwaysDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiIntegrationsCarbonCalculatorPathwaysDestroyError,
    ApiIntegrationsCarbonCalculatorPathwaysDestroyVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorPathwaysDestroyVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorPathwaysDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorVariableQuestionsListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiIntegrationsCarbonCalculatorVariableQuestionsListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariableQuestionsListVariables = {
  queryParams?: ApiIntegrationsCarbonCalculatorVariableQuestionsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariableQuestionsList = (
  variables: ApiIntegrationsCarbonCalculatorVariableQuestionsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedCarbonCalculatorVariableQuestionList,
    ApiIntegrationsCarbonCalculatorVariableQuestionsListError,
    undefined,
    {},
    ApiIntegrationsCarbonCalculatorVariableQuestionsListQueryParams,
    {}
  >({
    url: "/api/integrations/carbon-calculator/variable-questions/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariableQuestionsList = <
  TData = Schemas.PaginatedCarbonCalculatorVariableQuestionList,
>(
  variables: ApiIntegrationsCarbonCalculatorVariableQuestionsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedCarbonCalculatorVariableQuestionList,
      ApiIntegrationsCarbonCalculatorVariableQuestionsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedCarbonCalculatorVariableQuestionList,
    ApiIntegrationsCarbonCalculatorVariableQuestionsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/integrations/carbon-calculator/variable-questions/",
      operationId: "apiIntegrationsCarbonCalculatorVariableQuestionsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiIntegrationsCarbonCalculatorVariableQuestionsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiIntegrationsCarbonCalculatorVariableQuestionsCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariableQuestionsCreateVariables = {
  body: Schemas.CarbonCalculatorVariableQuestionRequest;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariableQuestionsCreate = (
  variables: ApiIntegrationsCarbonCalculatorVariableQuestionsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorVariableQuestion,
    ApiIntegrationsCarbonCalculatorVariableQuestionsCreateError,
    Schemas.CarbonCalculatorVariableQuestionRequest,
    {},
    {},
    {}
  >({
    url: "/api/integrations/carbon-calculator/variable-questions/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariableQuestionsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorVariableQuestion,
      ApiIntegrationsCarbonCalculatorVariableQuestionsCreateError,
      ApiIntegrationsCarbonCalculatorVariableQuestionsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorVariableQuestion,
    ApiIntegrationsCarbonCalculatorVariableQuestionsCreateError,
    ApiIntegrationsCarbonCalculatorVariableQuestionsCreateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorVariableQuestionsCreateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorVariableQuestionsCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorVariableQuestionsRetrievePathParams =
  {
    /**
     * @format uuid
     */
    id: string;
  };

export type ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveVariables =
  {
    pathParams: ApiIntegrationsCarbonCalculatorVariableQuestionsRetrievePathParams;
  } & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariableQuestionsRetrieve = (
  variables: ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorVariableQuestion,
    ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveError,
    undefined,
    {},
    {},
    ApiIntegrationsCarbonCalculatorVariableQuestionsRetrievePathParams
  >({
    url: "/api/integrations/carbon-calculator/variable-questions/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariableQuestionsRetrieve = <
  TData = Schemas.CarbonCalculatorVariableQuestion,
>(
  variables: ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CarbonCalculatorVariableQuestion,
      ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.CarbonCalculatorVariableQuestion,
    ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/integrations/carbon-calculator/variable-questions/{id}/",
      operationId: "apiIntegrationsCarbonCalculatorVariableQuestionsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiIntegrationsCarbonCalculatorVariableQuestionsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiIntegrationsCarbonCalculatorVariableQuestionsUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateVariables = {
  body: Schemas.CarbonCalculatorVariableQuestionRequest;
  pathParams: ApiIntegrationsCarbonCalculatorVariableQuestionsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariableQuestionsUpdate = (
  variables: ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorVariableQuestion,
    ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateError,
    Schemas.CarbonCalculatorVariableQuestionRequest,
    {},
    {},
    ApiIntegrationsCarbonCalculatorVariableQuestionsUpdatePathParams
  >({
    url: "/api/integrations/carbon-calculator/variable-questions/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariableQuestionsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorVariableQuestion,
      ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateError,
      ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorVariableQuestion,
    ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateError,
    ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorVariableQuestionsUpdateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorVariableQuestionsUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdatePathParams =
  {
    /**
     * @format uuid
     */
    id: string;
  };

export type ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateVariables =
  {
    body?: Schemas.PatchedCarbonCalculatorVariableQuestionRequest;
    pathParams: ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdatePathParams;
  } & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdate =
  (
    variables: ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateVariables,
    signal?: AbortSignal,
  ) =>
    lctApIFetch<
      Schemas.CarbonCalculatorVariableQuestion,
      ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateError,
      Schemas.PatchedCarbonCalculatorVariableQuestionRequest,
      {},
      {},
      ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdatePathParams
    >({
      url: "/api/integrations/carbon-calculator/variable-questions/{id}/",
      method: "patch",
      ...variables,
      signal,
    });

export const useApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdate =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.CarbonCalculatorVariableQuestion,
        ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateError,
        ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateVariables
      >,
      "mutationFn"
    >,
  ) => {
    const { fetcherOptions } = useLctApIContext();
    return reactQuery.useMutation<
      Schemas.CarbonCalculatorVariableQuestion,
      ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateError,
      ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateVariables
    >({
      mutationFn: (
        variables: ApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdateVariables,
      ) =>
        fetchApiIntegrationsCarbonCalculatorVariableQuestionsPartialUpdate({
          ...fetcherOptions,
          ...variables,
        }),
      ...options,
    });
  };

export type ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyPathParams =
  {
    /**
     * @format uuid
     */
    id: string;
  };

export type ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyVariables = {
  pathParams: ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariableQuestionsDestroy = (
  variables: ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyError,
    undefined,
    {},
    {},
    ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyPathParams
  >({
    url: "/api/integrations/carbon-calculator/variable-questions/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariableQuestionsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyError,
      ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyError,
    ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorVariableQuestionsDestroyVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorVariableQuestionsDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorVariablesListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiIntegrationsCarbonCalculatorVariablesListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariablesListVariables = {
  queryParams?: ApiIntegrationsCarbonCalculatorVariablesListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariablesList = (
  variables: ApiIntegrationsCarbonCalculatorVariablesListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedCarbonCalculatorVariableList,
    ApiIntegrationsCarbonCalculatorVariablesListError,
    undefined,
    {},
    ApiIntegrationsCarbonCalculatorVariablesListQueryParams,
    {}
  >({
    url: "/api/integrations/carbon-calculator/variables/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariablesList = <
  TData = Schemas.PaginatedCarbonCalculatorVariableList,
>(
  variables: ApiIntegrationsCarbonCalculatorVariablesListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedCarbonCalculatorVariableList,
      ApiIntegrationsCarbonCalculatorVariablesListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedCarbonCalculatorVariableList,
    ApiIntegrationsCarbonCalculatorVariablesListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/integrations/carbon-calculator/variables/",
      operationId: "apiIntegrationsCarbonCalculatorVariablesList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiIntegrationsCarbonCalculatorVariablesList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiIntegrationsCarbonCalculatorVariablesCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariablesCreateVariables = {
  body: Schemas.CarbonCalculatorVariableRequest;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariablesCreate = (
  variables: ApiIntegrationsCarbonCalculatorVariablesCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesCreateError,
    Schemas.CarbonCalculatorVariableRequest,
    {},
    {},
    {}
  >({
    url: "/api/integrations/carbon-calculator/variables/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariablesCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorVariable,
      ApiIntegrationsCarbonCalculatorVariablesCreateError,
      ApiIntegrationsCarbonCalculatorVariablesCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesCreateError,
    ApiIntegrationsCarbonCalculatorVariablesCreateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorVariablesCreateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorVariablesCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorVariablesRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorVariablesRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariablesRetrieveVariables = {
  pathParams: ApiIntegrationsCarbonCalculatorVariablesRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariablesRetrieve = (
  variables: ApiIntegrationsCarbonCalculatorVariablesRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesRetrieveError,
    undefined,
    {},
    {},
    ApiIntegrationsCarbonCalculatorVariablesRetrievePathParams
  >({
    url: "/api/integrations/carbon-calculator/variables/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariablesRetrieve = <
  TData = Schemas.CarbonCalculatorVariable,
>(
  variables: ApiIntegrationsCarbonCalculatorVariablesRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CarbonCalculatorVariable,
      ApiIntegrationsCarbonCalculatorVariablesRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/integrations/carbon-calculator/variables/{id}/",
      operationId: "apiIntegrationsCarbonCalculatorVariablesRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiIntegrationsCarbonCalculatorVariablesRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiIntegrationsCarbonCalculatorVariablesUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorVariablesUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariablesUpdateVariables = {
  body: Schemas.CarbonCalculatorVariableRequest;
  pathParams: ApiIntegrationsCarbonCalculatorVariablesUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariablesUpdate = (
  variables: ApiIntegrationsCarbonCalculatorVariablesUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesUpdateError,
    Schemas.CarbonCalculatorVariableRequest,
    {},
    {},
    ApiIntegrationsCarbonCalculatorVariablesUpdatePathParams
  >({
    url: "/api/integrations/carbon-calculator/variables/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariablesUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorVariable,
      ApiIntegrationsCarbonCalculatorVariablesUpdateError,
      ApiIntegrationsCarbonCalculatorVariablesUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesUpdateError,
    ApiIntegrationsCarbonCalculatorVariablesUpdateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorVariablesUpdateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorVariablesUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorVariablesPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorVariablesPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariablesPartialUpdateVariables = {
  body?: Schemas.PatchedCarbonCalculatorVariableRequest;
  pathParams: ApiIntegrationsCarbonCalculatorVariablesPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariablesPartialUpdate = (
  variables: ApiIntegrationsCarbonCalculatorVariablesPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesPartialUpdateError,
    Schemas.PatchedCarbonCalculatorVariableRequest,
    {},
    {},
    ApiIntegrationsCarbonCalculatorVariablesPartialUpdatePathParams
  >({
    url: "/api/integrations/carbon-calculator/variables/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariablesPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CarbonCalculatorVariable,
      ApiIntegrationsCarbonCalculatorVariablesPartialUpdateError,
      ApiIntegrationsCarbonCalculatorVariablesPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.CarbonCalculatorVariable,
    ApiIntegrationsCarbonCalculatorVariablesPartialUpdateError,
    ApiIntegrationsCarbonCalculatorVariablesPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorVariablesPartialUpdateVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorVariablesPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiIntegrationsCarbonCalculatorVariablesDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiIntegrationsCarbonCalculatorVariablesDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationsCarbonCalculatorVariablesDestroyVariables = {
  pathParams: ApiIntegrationsCarbonCalculatorVariablesDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiIntegrationsCarbonCalculatorVariablesDestroy = (
  variables: ApiIntegrationsCarbonCalculatorVariablesDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiIntegrationsCarbonCalculatorVariablesDestroyError,
    undefined,
    {},
    {},
    ApiIntegrationsCarbonCalculatorVariablesDestroyPathParams
  >({
    url: "/api/integrations/carbon-calculator/variables/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiIntegrationsCarbonCalculatorVariablesDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiIntegrationsCarbonCalculatorVariablesDestroyError,
      ApiIntegrationsCarbonCalculatorVariablesDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiIntegrationsCarbonCalculatorVariablesDestroyError,
    ApiIntegrationsCarbonCalculatorVariablesDestroyVariables
  >({
    mutationFn: (
      variables: ApiIntegrationsCarbonCalculatorVariablesDestroyVariables,
    ) =>
      fetchApiIntegrationsCarbonCalculatorVariablesDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiPvpListError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpListVariables = {
  queryParams?: ApiPvpListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpList = (
  variables: ApiPvpListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedPVPList,
    ApiPvpListError,
    undefined,
    {},
    ApiPvpListQueryParams,
    {}
  >({ url: "/api/pvp/", method: "get", ...variables, signal });

export const useApiPvpList = <TData = Schemas.PaginatedPVPList,>(
  variables: ApiPvpListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedPVPList,
      ApiPvpListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<Schemas.PaginatedPVPList, ApiPvpListError, TData>({
    queryKey: queryKeyFn({
      path: "/api/pvp/",
      operationId: "apiPvpList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpCreateError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpCreateVariables = {
  body: Schemas.PVPRequest;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpCreate = (
  variables: ApiPvpCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<Schemas.Pvp, ApiPvpCreateError, Schemas.PVPRequest, {}, {}, {}>({
    url: "/api/pvp/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Pvp,
      ApiPvpCreateError,
      ApiPvpCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Pvp,
    ApiPvpCreateError,
    ApiPvpCreateVariables
  >({
    mutationFn: (variables: ApiPvpCreateVariables) =>
      fetchApiPvpCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPvpRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiPvpRetrieveError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpRetrieveVariables = {
  pathParams: ApiPvpRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpRetrieve = (
  variables: ApiPvpRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Pvp,
    ApiPvpRetrieveError,
    undefined,
    {},
    {},
    ApiPvpRetrievePathParams
  >({ url: "/api/pvp/{id}/", method: "get", ...variables, signal });

export const useApiPvpRetrieve = <TData = Schemas.Pvp,>(
  variables: ApiPvpRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Pvp, ApiPvpRetrieveError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<Schemas.Pvp, ApiPvpRetrieveError, TData>({
    queryKey: queryKeyFn({
      path: "/api/pvp/{id}/",
      operationId: "apiPvpRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpRetrieve({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiPvpUpdateError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpUpdateVariables = {
  body: Schemas.PVPRequest;
  pathParams: ApiPvpUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpUpdate = (
  variables: ApiPvpUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Pvp,
    ApiPvpUpdateError,
    Schemas.PVPRequest,
    {},
    {},
    ApiPvpUpdatePathParams
  >({ url: "/api/pvp/{id}/", method: "put", ...variables, signal });

export const useApiPvpUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Pvp,
      ApiPvpUpdateError,
      ApiPvpUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Pvp,
    ApiPvpUpdateError,
    ApiPvpUpdateVariables
  >({
    mutationFn: (variables: ApiPvpUpdateVariables) =>
      fetchApiPvpUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPvpPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiPvpPartialUpdateError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpPartialUpdateVariables = {
  body?: Schemas.PatchedPVPRequest;
  pathParams: ApiPvpPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpPartialUpdate = (
  variables: ApiPvpPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Pvp,
    ApiPvpPartialUpdateError,
    Schemas.PatchedPVPRequest,
    {},
    {},
    ApiPvpPartialUpdatePathParams
  >({ url: "/api/pvp/{id}/", method: "patch", ...variables, signal });

export const useApiPvpPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Pvp,
      ApiPvpPartialUpdateError,
      ApiPvpPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Pvp,
    ApiPvpPartialUpdateError,
    ApiPvpPartialUpdateVariables
  >({
    mutationFn: (variables: ApiPvpPartialUpdateVariables) =>
      fetchApiPvpPartialUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPvpDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiPvpDestroyError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpDestroyVariables = {
  pathParams: ApiPvpDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpDestroy = (
  variables: ApiPvpDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiPvpDestroyError,
    undefined,
    {},
    {},
    ApiPvpDestroyPathParams
  >({ url: "/api/pvp/{id}/", method: "delete", ...variables, signal });

export const useApiPvpDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPvpDestroyError,
      ApiPvpDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiPvpDestroyError,
    ApiPvpDestroyVariables
  >({
    mutationFn: (variables: ApiPvpDestroyVariables) =>
      fetchApiPvpDestroy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPvpApplicationsListPathParams = {
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiPvpApplicationsListError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsListVariables = {
  pathParams: ApiPvpApplicationsListPathParams;
  queryParams?: ApiPvpApplicationsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsList = (
  variables: ApiPvpApplicationsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedApplicationList,
    ApiPvpApplicationsListError,
    undefined,
    {},
    ApiPvpApplicationsListQueryParams,
    ApiPvpApplicationsListPathParams
  >({
    url: "/api/pvp/{pvp}/applications/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsList = <
  TData = Schemas.PaginatedApplicationList,
>(
  variables: ApiPvpApplicationsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedApplicationList,
      ApiPvpApplicationsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedApplicationList,
    ApiPvpApplicationsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/",
      operationId: "apiPvpApplicationsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsCreatePathParams = {
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsCreateError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsCreateVariables = {
  body: Schemas.ApplicationRequest;
  pathParams: ApiPvpApplicationsCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsCreate = (
  variables: ApiPvpApplicationsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Application,
    ApiPvpApplicationsCreateError,
    Schemas.ApplicationRequest,
    {},
    {},
    ApiPvpApplicationsCreatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Application,
      ApiPvpApplicationsCreateError,
      ApiPvpApplicationsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Application,
    ApiPvpApplicationsCreateError,
    ApiPvpApplicationsCreateVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsCreateVariables) =>
      fetchApiPvpApplicationsCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsListPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsSectionsListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiPvpApplicationsSectionsListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsListVariables = {
  pathParams: ApiPvpApplicationsSectionsListPathParams;
  queryParams?: ApiPvpApplicationsSectionsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsList = (
  variables: ApiPvpApplicationsSectionsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedApplicationSectionList,
    ApiPvpApplicationsSectionsListError,
    undefined,
    {},
    ApiPvpApplicationsSectionsListQueryParams,
    ApiPvpApplicationsSectionsListPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsList = <
  TData = Schemas.PaginatedApplicationSectionList,
>(
  variables: ApiPvpApplicationsSectionsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedApplicationSectionList,
      ApiPvpApplicationsSectionsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedApplicationSectionList,
    ApiPvpApplicationsSectionsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/sections/",
      operationId: "apiPvpApplicationsSectionsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsSectionsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsSectionsCreatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsSectionsCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsCreateVariables = {
  body?: Schemas.ApplicationSectionRequest;
  pathParams: ApiPvpApplicationsSectionsCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsCreate = (
  variables: ApiPvpApplicationsSectionsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsCreateError,
    Schemas.ApplicationSectionRequest,
    {},
    {},
    ApiPvpApplicationsSectionsCreatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationSection,
      ApiPvpApplicationsSectionsCreateError,
      ApiPvpApplicationsSectionsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsCreateError,
    ApiPvpApplicationsSectionsCreateVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsSectionsCreateVariables) =>
      fetchApiPvpApplicationsSectionsCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsRetrievePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsSectionsRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsRetrieveVariables = {
  pathParams: ApiPvpApplicationsSectionsRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsRetrieve = (
  variables: ApiPvpApplicationsSectionsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsRetrieveError,
    undefined,
    {},
    {},
    ApiPvpApplicationsSectionsRetrievePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsRetrieve = <
  TData = Schemas.ApplicationSection,
>(
  variables: ApiPvpApplicationsSectionsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ApplicationSection,
      ApiPvpApplicationsSectionsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/sections/{id}/",
      operationId: "apiPvpApplicationsSectionsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsSectionsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsSectionsUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsSectionsUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsUpdateVariables = {
  body?: Schemas.ApplicationSectionRequest;
  pathParams: ApiPvpApplicationsSectionsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsUpdate = (
  variables: ApiPvpApplicationsSectionsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsUpdateError,
    Schemas.ApplicationSectionRequest,
    {},
    {},
    ApiPvpApplicationsSectionsUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationSection,
      ApiPvpApplicationsSectionsUpdateError,
      ApiPvpApplicationsSectionsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsUpdateError,
    ApiPvpApplicationsSectionsUpdateVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsSectionsUpdateVariables) =>
      fetchApiPvpApplicationsSectionsUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsSectionsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsPartialUpdateVariables = {
  body?: Schemas.PatchedApplicationSectionRequest;
  pathParams: ApiPvpApplicationsSectionsPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsPartialUpdate = (
  variables: ApiPvpApplicationsSectionsPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsPartialUpdateError,
    Schemas.PatchedApplicationSectionRequest,
    {},
    {},
    ApiPvpApplicationsSectionsPartialUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationSection,
      ApiPvpApplicationsSectionsPartialUpdateError,
      ApiPvpApplicationsSectionsPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationSection,
    ApiPvpApplicationsSectionsPartialUpdateError,
    ApiPvpApplicationsSectionsPartialUpdateVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsSectionsPartialUpdateVariables) =>
      fetchApiPvpApplicationsSectionsPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsDestroyPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsSectionsDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsDestroyVariables = {
  pathParams: ApiPvpApplicationsSectionsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsDestroy = (
  variables: ApiPvpApplicationsSectionsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiPvpApplicationsSectionsDestroyError,
    undefined,
    {},
    {},
    ApiPvpApplicationsSectionsDestroyPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPvpApplicationsSectionsDestroyError,
      ApiPvpApplicationsSectionsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiPvpApplicationsSectionsDestroyError,
    ApiPvpApplicationsSectionsDestroyVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsSectionsDestroyVariables) =>
      fetchApiPvpApplicationsSectionsDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsQuestionsListPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  section: string;
};

export type ApiPvpApplicationsSectionsQuestionsListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiPvpApplicationsSectionsQuestionsListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsQuestionsListVariables = {
  pathParams: ApiPvpApplicationsSectionsQuestionsListPathParams;
  queryParams?: ApiPvpApplicationsSectionsQuestionsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsQuestionsList = (
  variables: ApiPvpApplicationsSectionsQuestionsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedApplicationQuestionList,
    ApiPvpApplicationsSectionsQuestionsListError,
    undefined,
    {},
    ApiPvpApplicationsSectionsQuestionsListQueryParams,
    ApiPvpApplicationsSectionsQuestionsListPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsQuestionsList = <
  TData = Schemas.PaginatedApplicationQuestionList,
>(
  variables: ApiPvpApplicationsSectionsQuestionsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedApplicationQuestionList,
      ApiPvpApplicationsSectionsQuestionsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedApplicationQuestionList,
    ApiPvpApplicationsSectionsQuestionsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/",
      operationId: "apiPvpApplicationsSectionsQuestionsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsSectionsQuestionsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsSectionsQuestionsCreatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  section: string;
};

export type ApiPvpApplicationsSectionsQuestionsCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsQuestionsCreateVariables = {
  body: Schemas.ApplicationQuestionRequest;
  pathParams: ApiPvpApplicationsSectionsQuestionsCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsQuestionsCreate = (
  variables: ApiPvpApplicationsSectionsQuestionsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsCreateError,
    Schemas.ApplicationQuestionRequest,
    {},
    {},
    ApiPvpApplicationsSectionsQuestionsCreatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsQuestionsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationQuestion,
      ApiPvpApplicationsSectionsQuestionsCreateError,
      ApiPvpApplicationsSectionsQuestionsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsCreateError,
    ApiPvpApplicationsSectionsQuestionsCreateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsSectionsQuestionsCreateVariables,
    ) =>
      fetchApiPvpApplicationsSectionsQuestionsCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsQuestionsRetrievePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  section: string;
};

export type ApiPvpApplicationsSectionsQuestionsRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsQuestionsRetrieveVariables = {
  pathParams: ApiPvpApplicationsSectionsQuestionsRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsQuestionsRetrieve = (
  variables: ApiPvpApplicationsSectionsQuestionsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsRetrieveError,
    undefined,
    {},
    {},
    ApiPvpApplicationsSectionsQuestionsRetrievePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsQuestionsRetrieve = <
  TData = Schemas.ApplicationQuestion,
>(
  variables: ApiPvpApplicationsSectionsQuestionsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ApplicationQuestion,
      ApiPvpApplicationsSectionsQuestionsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/{id}/",
      operationId: "apiPvpApplicationsSectionsQuestionsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsSectionsQuestionsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsSectionsQuestionsUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  section: string;
};

export type ApiPvpApplicationsSectionsQuestionsUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsQuestionsUpdateVariables = {
  body: Schemas.ApplicationQuestionRequest;
  pathParams: ApiPvpApplicationsSectionsQuestionsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsQuestionsUpdate = (
  variables: ApiPvpApplicationsSectionsQuestionsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsUpdateError,
    Schemas.ApplicationQuestionRequest,
    {},
    {},
    ApiPvpApplicationsSectionsQuestionsUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsQuestionsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationQuestion,
      ApiPvpApplicationsSectionsQuestionsUpdateError,
      ApiPvpApplicationsSectionsQuestionsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsUpdateError,
    ApiPvpApplicationsSectionsQuestionsUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsSectionsQuestionsUpdateVariables,
    ) =>
      fetchApiPvpApplicationsSectionsQuestionsUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsQuestionsPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  section: string;
};

export type ApiPvpApplicationsSectionsQuestionsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsQuestionsPartialUpdateVariables = {
  body?: Schemas.PatchedApplicationQuestionRequest;
  pathParams: ApiPvpApplicationsSectionsQuestionsPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsQuestionsPartialUpdate = (
  variables: ApiPvpApplicationsSectionsQuestionsPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsPartialUpdateError,
    Schemas.PatchedApplicationQuestionRequest,
    {},
    {},
    ApiPvpApplicationsSectionsQuestionsPartialUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsQuestionsPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationQuestion,
      ApiPvpApplicationsSectionsQuestionsPartialUpdateError,
      ApiPvpApplicationsSectionsQuestionsPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationQuestion,
    ApiPvpApplicationsSectionsQuestionsPartialUpdateError,
    ApiPvpApplicationsSectionsQuestionsPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsSectionsQuestionsPartialUpdateVariables,
    ) =>
      fetchApiPvpApplicationsSectionsQuestionsPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsSectionsQuestionsDestroyPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  section: string;
};

export type ApiPvpApplicationsSectionsQuestionsDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsSectionsQuestionsDestroyVariables = {
  pathParams: ApiPvpApplicationsSectionsQuestionsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsSectionsQuestionsDestroy = (
  variables: ApiPvpApplicationsSectionsQuestionsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiPvpApplicationsSectionsQuestionsDestroyError,
    undefined,
    {},
    {},
    ApiPvpApplicationsSectionsQuestionsDestroyPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsSectionsQuestionsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPvpApplicationsSectionsQuestionsDestroyError,
      ApiPvpApplicationsSectionsQuestionsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiPvpApplicationsSectionsQuestionsDestroyError,
    ApiPvpApplicationsSectionsQuestionsDestroyVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsSectionsQuestionsDestroyVariables,
    ) =>
      fetchApiPvpApplicationsSectionsQuestionsDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsListPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * * `STARTED` - Started
   * * `PART_1_SUBMITTED` - Part 1 Submitted
   * * `PART_1_APPROVED` - Part 1 Approved
   * * `PART_2_SUBMITTED` - Part 2 Submitted
   * * `REJECTED` - Rejected
   * * `APPROVED` - Application Approved
   * * `FURTHER_INFO_PART_1` - Further Information Required (Part 1)
   * * `FURTHER_INFO_PART_2` - Further Information Required (Part 2)
   */
  status?:
    | "APPROVED"
    | "FURTHER_INFO_PART_1"
    | "FURTHER_INFO_PART_2"
    | "PART_1_APPROVED"
    | "PART_1_SUBMITTED"
    | "PART_2_SUBMITTED"
    | "REJECTED"
    | "STARTED";
  user?: number;
};

export type ApiPvpApplicationsUserApplicationsListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsListVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsListPathParams;
  queryParams?: ApiPvpApplicationsUserApplicationsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsList = (
  variables: ApiPvpApplicationsUserApplicationsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedUserApplicationList,
    ApiPvpApplicationsUserApplicationsListError,
    undefined,
    {},
    ApiPvpApplicationsUserApplicationsListQueryParams,
    ApiPvpApplicationsUserApplicationsListPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsList = <
  TData = Schemas.PaginatedUserApplicationList,
>(
  variables: ApiPvpApplicationsUserApplicationsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedUserApplicationList,
      ApiPvpApplicationsUserApplicationsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedUserApplicationList,
    ApiPvpApplicationsUserApplicationsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/",
      operationId: "apiPvpApplicationsUserApplicationsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsUserApplicationsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsUserApplicationsCreatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsCreateVariables = {
  body?: Schemas.UserApplicationRequest;
  pathParams: ApiPvpApplicationsUserApplicationsCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsCreate = (
  variables: ApiPvpApplicationsUserApplicationsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsCreateError,
    Schemas.UserApplicationRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsCreatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplication,
      ApiPvpApplicationsUserApplicationsCreateError,
      ApiPvpApplicationsUserApplicationsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsCreateError,
    ApiPvpApplicationsUserApplicationsCreateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsCreateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsRetrievePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsRetrieveVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsRetrieve = (
  variables: ApiPvpApplicationsUserApplicationsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsRetrieveError,
    undefined,
    {},
    {},
    ApiPvpApplicationsUserApplicationsRetrievePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsRetrieve = <
  TData = Schemas.UserApplication,
>(
  variables: ApiPvpApplicationsUserApplicationsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserApplication,
      ApiPvpApplicationsUserApplicationsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/",
      operationId: "apiPvpApplicationsUserApplicationsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsUserApplicationsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsUserApplicationsUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsUpdateVariables = {
  body?: Schemas.UserApplicationRequest;
  pathParams: ApiPvpApplicationsUserApplicationsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsUpdate = (
  variables: ApiPvpApplicationsUserApplicationsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsUpdateError,
    Schemas.UserApplicationRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplication,
      ApiPvpApplicationsUserApplicationsUpdateError,
      ApiPvpApplicationsUserApplicationsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsUpdateError,
    ApiPvpApplicationsUserApplicationsUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsUpdateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsPartialUpdateVariables = {
  body?: Schemas.PatchedUserApplicationRequest;
  pathParams: ApiPvpApplicationsUserApplicationsPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsPartialUpdate = (
  variables: ApiPvpApplicationsUserApplicationsPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsPartialUpdateError,
    Schemas.PatchedUserApplicationRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsPartialUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplication,
      ApiPvpApplicationsUserApplicationsPartialUpdateError,
      ApiPvpApplicationsUserApplicationsPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplication,
    ApiPvpApplicationsUserApplicationsPartialUpdateError,
    ApiPvpApplicationsUserApplicationsPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsPartialUpdateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsDestroyPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsDestroyVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsDestroy = (
  variables: ApiPvpApplicationsUserApplicationsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiPvpApplicationsUserApplicationsDestroyError,
    undefined,
    {},
    {},
    ApiPvpApplicationsUserApplicationsDestroyPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPvpApplicationsUserApplicationsDestroyError,
      ApiPvpApplicationsUserApplicationsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiPvpApplicationsUserApplicationsDestroyError,
    ApiPvpApplicationsUserApplicationsDestroyVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsDestroyVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsAnswersListPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsAnswersListQueryParams = {
  /**
   * @format uuid
   */
  application_question?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiPvpApplicationsUserApplicationsAnswersListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsAnswersListVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsAnswersListPathParams;
  queryParams?: ApiPvpApplicationsUserApplicationsAnswersListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsAnswersList = (
  variables: ApiPvpApplicationsUserApplicationsAnswersListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedApplicationAnswerDetailList,
    ApiPvpApplicationsUserApplicationsAnswersListError,
    undefined,
    {},
    ApiPvpApplicationsUserApplicationsAnswersListQueryParams,
    ApiPvpApplicationsUserApplicationsAnswersListPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/answers/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsAnswersList = <
  TData = Schemas.PaginatedApplicationAnswerDetailList,
>(
  variables: ApiPvpApplicationsUserApplicationsAnswersListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedApplicationAnswerDetailList,
      ApiPvpApplicationsUserApplicationsAnswersListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedApplicationAnswerDetailList,
    ApiPvpApplicationsUserApplicationsAnswersListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/answers/",
      operationId: "apiPvpApplicationsUserApplicationsAnswersList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsUserApplicationsAnswersList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsUserApplicationsAnswersCreatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsAnswersCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsAnswersCreateVariables = {
  body: Schemas.ApplicationAnswerDetailRequest;
  pathParams: ApiPvpApplicationsUserApplicationsAnswersCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsAnswersCreate = (
  variables: ApiPvpApplicationsUserApplicationsAnswersCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersCreateError,
    Schemas.ApplicationAnswerDetailRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsAnswersCreatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/answers/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsAnswersCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerDetail,
      ApiPvpApplicationsUserApplicationsAnswersCreateError,
      ApiPvpApplicationsUserApplicationsAnswersCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersCreateError,
    ApiPvpApplicationsUserApplicationsAnswersCreateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsAnswersCreateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsAnswersCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsBulkSaveCreatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUserApplicationsBulkSaveCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsBulkSaveCreateVariables = {
  body: Schemas.ApplicationAnswerBulkCreateRequest;
  pathParams: ApiPvpApplicationsUserApplicationsBulkSaveCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsBulkSaveCreate = (
  variables: ApiPvpApplicationsUserApplicationsBulkSaveCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerBulkCreate,
    ApiPvpApplicationsUserApplicationsBulkSaveCreateError,
    Schemas.ApplicationAnswerBulkCreateRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsBulkSaveCreatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/bulk-save",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsBulkSaveCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerBulkCreate,
      ApiPvpApplicationsUserApplicationsBulkSaveCreateError,
      ApiPvpApplicationsUserApplicationsBulkSaveCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerBulkCreate,
    ApiPvpApplicationsUserApplicationsBulkSaveCreateError,
    ApiPvpApplicationsUserApplicationsBulkSaveCreateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsBulkSaveCreateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsBulkSaveCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsAnswersRetrievePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsAnswersRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsAnswersRetrieveVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsAnswersRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsAnswersRetrieve = (
  variables: ApiPvpApplicationsUserApplicationsAnswersRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersRetrieveError,
    undefined,
    {},
    {},
    ApiPvpApplicationsUserApplicationsAnswersRetrievePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/answers/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsAnswersRetrieve = <
  TData = Schemas.ApplicationAnswerDetail,
>(
  variables: ApiPvpApplicationsUserApplicationsAnswersRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ApplicationAnswerDetail,
      ApiPvpApplicationsUserApplicationsAnswersRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/answers/{id}/",
      operationId: "apiPvpApplicationsUserApplicationsAnswersRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsUserApplicationsAnswersRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsUserApplicationsAnswersUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsAnswersUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsAnswersUpdateVariables = {
  body: Schemas.ApplicationAnswerDetailRequest;
  pathParams: ApiPvpApplicationsUserApplicationsAnswersUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsAnswersUpdate = (
  variables: ApiPvpApplicationsUserApplicationsAnswersUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersUpdateError,
    Schemas.ApplicationAnswerDetailRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsAnswersUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/answers/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsAnswersUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerDetail,
      ApiPvpApplicationsUserApplicationsAnswersUpdateError,
      ApiPvpApplicationsUserApplicationsAnswersUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersUpdateError,
    ApiPvpApplicationsUserApplicationsAnswersUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsAnswersUpdateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsAnswersUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsAnswersPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsAnswersPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsAnswersPartialUpdateVariables = {
  body?: Schemas.PatchedApplicationAnswerDetailRequest;
  pathParams: ApiPvpApplicationsUserApplicationsAnswersPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsAnswersPartialUpdate = (
  variables: ApiPvpApplicationsUserApplicationsAnswersPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersPartialUpdateError,
    Schemas.PatchedApplicationAnswerDetailRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsAnswersPartialUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/answers/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsAnswersPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerDetail,
      ApiPvpApplicationsUserApplicationsAnswersPartialUpdateError,
      ApiPvpApplicationsUserApplicationsAnswersPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerDetail,
    ApiPvpApplicationsUserApplicationsAnswersPartialUpdateError,
    ApiPvpApplicationsUserApplicationsAnswersPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsAnswersPartialUpdateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsAnswersPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsAnswersDestroyPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsAnswersDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsAnswersDestroyVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsAnswersDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsAnswersDestroy = (
  variables: ApiPvpApplicationsUserApplicationsAnswersDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiPvpApplicationsUserApplicationsAnswersDestroyError,
    undefined,
    {},
    {},
    ApiPvpApplicationsUserApplicationsAnswersDestroyPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/answers/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsAnswersDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPvpApplicationsUserApplicationsAnswersDestroyError,
      ApiPvpApplicationsUserApplicationsAnswersDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiPvpApplicationsUserApplicationsAnswersDestroyError,
    ApiPvpApplicationsUserApplicationsAnswersDestroyVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsAnswersDestroyVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsAnswersDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsCommentsListPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsCommentsListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiPvpApplicationsUserApplicationsCommentsListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsCommentsListVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsCommentsListPathParams;
  queryParams?: ApiPvpApplicationsUserApplicationsCommentsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsCommentsList = (
  variables: ApiPvpApplicationsUserApplicationsCommentsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedUserApplicationCommentList,
    ApiPvpApplicationsUserApplicationsCommentsListError,
    undefined,
    {},
    ApiPvpApplicationsUserApplicationsCommentsListQueryParams,
    ApiPvpApplicationsUserApplicationsCommentsListPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsCommentsList = <
  TData = Schemas.PaginatedUserApplicationCommentList,
>(
  variables: ApiPvpApplicationsUserApplicationsCommentsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedUserApplicationCommentList,
      ApiPvpApplicationsUserApplicationsCommentsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedUserApplicationCommentList,
    ApiPvpApplicationsUserApplicationsCommentsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/",
      operationId: "apiPvpApplicationsUserApplicationsCommentsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsUserApplicationsCommentsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsUserApplicationsCommentsCreatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsCommentsCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsCommentsCreateVariables = {
  body: Schemas.UserApplicationCommentRequest;
  pathParams: ApiPvpApplicationsUserApplicationsCommentsCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsCommentsCreate = (
  variables: ApiPvpApplicationsUserApplicationsCommentsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsCreateError,
    Schemas.UserApplicationCommentRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsCommentsCreatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsCommentsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplicationComment,
      ApiPvpApplicationsUserApplicationsCommentsCreateError,
      ApiPvpApplicationsUserApplicationsCommentsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsCreateError,
    ApiPvpApplicationsUserApplicationsCommentsCreateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsCommentsCreateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsCommentsCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsCommentsRetrievePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsCommentsRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsCommentsRetrieveVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsCommentsRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsCommentsRetrieve = (
  variables: ApiPvpApplicationsUserApplicationsCommentsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsRetrieveError,
    undefined,
    {},
    {},
    ApiPvpApplicationsUserApplicationsCommentsRetrievePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsCommentsRetrieve = <
  TData = Schemas.UserApplicationComment,
>(
  variables: ApiPvpApplicationsUserApplicationsCommentsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserApplicationComment,
      ApiPvpApplicationsUserApplicationsCommentsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/{id}/",
      operationId: "apiPvpApplicationsUserApplicationsCommentsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsUserApplicationsCommentsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsUserApplicationsCommentsUpdatePathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsCommentsUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsCommentsUpdateVariables = {
  body: Schemas.UserApplicationCommentRequest;
  pathParams: ApiPvpApplicationsUserApplicationsCommentsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsCommentsUpdate = (
  variables: ApiPvpApplicationsUserApplicationsCommentsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsUpdateError,
    Schemas.UserApplicationCommentRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsCommentsUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsCommentsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplicationComment,
      ApiPvpApplicationsUserApplicationsCommentsUpdateError,
      ApiPvpApplicationsUserApplicationsCommentsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsUpdateError,
    ApiPvpApplicationsUserApplicationsCommentsUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsCommentsUpdateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsCommentsUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsCommentsPartialUpdatePathParams =
  {
    /**
     * @format uuid
     */
    app: string;
    /**
     * @format uuid
     */
    id: string;
    /**
     * @format uuid
     */
    pvp: string;
    /**
     * @format uuid
     */
    userapp: string;
  };

export type ApiPvpApplicationsUserApplicationsCommentsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsCommentsPartialUpdateVariables = {
  body?: Schemas.PatchedUserApplicationCommentRequest;
  pathParams: ApiPvpApplicationsUserApplicationsCommentsPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsCommentsPartialUpdate = (
  variables: ApiPvpApplicationsUserApplicationsCommentsPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsPartialUpdateError,
    Schemas.PatchedUserApplicationCommentRequest,
    {},
    {},
    ApiPvpApplicationsUserApplicationsCommentsPartialUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsCommentsPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplicationComment,
      ApiPvpApplicationsUserApplicationsCommentsPartialUpdateError,
      ApiPvpApplicationsUserApplicationsCommentsPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplicationComment,
    ApiPvpApplicationsUserApplicationsCommentsPartialUpdateError,
    ApiPvpApplicationsUserApplicationsCommentsPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsCommentsPartialUpdateVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsCommentsPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsUserApplicationsCommentsDestroyPathParams = {
  /**
   * @format uuid
   */
  app: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiPvpApplicationsUserApplicationsCommentsDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUserApplicationsCommentsDestroyVariables = {
  pathParams: ApiPvpApplicationsUserApplicationsCommentsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUserApplicationsCommentsDestroy = (
  variables: ApiPvpApplicationsUserApplicationsCommentsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiPvpApplicationsUserApplicationsCommentsDestroyError,
    undefined,
    {},
    {},
    ApiPvpApplicationsUserApplicationsCommentsDestroyPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUserApplicationsCommentsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPvpApplicationsUserApplicationsCommentsDestroyError,
      ApiPvpApplicationsUserApplicationsCommentsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiPvpApplicationsUserApplicationsCommentsDestroyError,
    ApiPvpApplicationsUserApplicationsCommentsDestroyVariables
  >({
    mutationFn: (
      variables: ApiPvpApplicationsUserApplicationsCommentsDestroyVariables,
    ) =>
      fetchApiPvpApplicationsUserApplicationsCommentsDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPvpApplicationsRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsRetrieveError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsRetrieveVariables = {
  pathParams: ApiPvpApplicationsRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsRetrieve = (
  variables: ApiPvpApplicationsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Application,
    ApiPvpApplicationsRetrieveError,
    undefined,
    {},
    {},
    ApiPvpApplicationsRetrievePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsRetrieve = <TData = Schemas.Application,>(
  variables: ApiPvpApplicationsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Application,
      ApiPvpApplicationsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.Application,
    ApiPvpApplicationsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/pvp/{pvp}/applications/{id}/",
      operationId: "apiPvpApplicationsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiPvpApplicationsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiPvpApplicationsUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsUpdateError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsUpdateVariables = {
  body: Schemas.ApplicationRequest;
  pathParams: ApiPvpApplicationsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsUpdate = (
  variables: ApiPvpApplicationsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Application,
    ApiPvpApplicationsUpdateError,
    Schemas.ApplicationRequest,
    {},
    {},
    ApiPvpApplicationsUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Application,
      ApiPvpApplicationsUpdateError,
      ApiPvpApplicationsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Application,
    ApiPvpApplicationsUpdateError,
    ApiPvpApplicationsUpdateVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsUpdateVariables) =>
      fetchApiPvpApplicationsUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPvpApplicationsPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsPartialUpdateVariables = {
  body?: Schemas.PatchedApplicationRequest;
  pathParams: ApiPvpApplicationsPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsPartialUpdate = (
  variables: ApiPvpApplicationsPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Application,
    ApiPvpApplicationsPartialUpdateError,
    Schemas.PatchedApplicationRequest,
    {},
    {},
    ApiPvpApplicationsPartialUpdatePathParams
  >({
    url: "/api/pvp/{pvp}/applications/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Application,
      ApiPvpApplicationsPartialUpdateError,
      ApiPvpApplicationsPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Application,
    ApiPvpApplicationsPartialUpdateError,
    ApiPvpApplicationsPartialUpdateVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsPartialUpdateVariables) =>
      fetchApiPvpApplicationsPartialUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPvpApplicationsDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  pvp: string;
};

export type ApiPvpApplicationsDestroyError = Fetcher.ErrorWrapper<undefined>;

export type ApiPvpApplicationsDestroyVariables = {
  pathParams: ApiPvpApplicationsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiPvpApplicationsDestroy = (
  variables: ApiPvpApplicationsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiPvpApplicationsDestroyError,
    undefined,
    {},
    {},
    ApiPvpApplicationsDestroyPathParams
  >({
    url: "/api/pvp/{pvp}/applications/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiPvpApplicationsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPvpApplicationsDestroyError,
      ApiPvpApplicationsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiPvpApplicationsDestroyError,
    ApiPvpApplicationsDestroyVariables
  >({
    mutationFn: (variables: ApiPvpApplicationsDestroyVariables) =>
      fetchApiPvpApplicationsDestroy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUploadListQueryParams = {
  /**
   * @format uuid
   */
  associated_answer?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  uploaded_by?: number;
  /**
   * @format uuid
   */
  user_application?: string;
};

export type ApiUploadListError = Fetcher.ErrorWrapper<undefined>;

export type ApiUploadListVariables = {
  queryParams?: ApiUploadListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUploadList = (
  variables: ApiUploadListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedUploadedFileList,
    ApiUploadListError,
    undefined,
    {},
    ApiUploadListQueryParams,
    {}
  >({ url: "/api/upload/", method: "get", ...variables, signal });

export const useApiUploadList = <TData = Schemas.PaginatedUploadedFileList,>(
  variables: ApiUploadListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedUploadedFileList,
      ApiUploadListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedUploadedFileList,
    ApiUploadListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/upload/",
      operationId: "apiUploadList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUploadList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiUploadCreateError = Fetcher.ErrorWrapper<undefined>;

export type ApiUploadCreateVariables = {
  body: Schemas.UploadedFileRequest;
} & LctApIContext["fetcherOptions"];

export const fetchApiUploadCreate = (
  variables: ApiUploadCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UploadedFile,
    ApiUploadCreateError,
    Schemas.UploadedFileRequest,
    {},
    {},
    {}
  >({ url: "/api/upload/", method: "post", ...variables, signal });

export const useApiUploadCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UploadedFile,
      ApiUploadCreateError,
      ApiUploadCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UploadedFile,
    ApiUploadCreateError,
    ApiUploadCreateVariables
  >({
    mutationFn: (variables: ApiUploadCreateVariables) =>
      fetchApiUploadCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUploadRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUploadRetrieveError = Fetcher.ErrorWrapper<undefined>;

export type ApiUploadRetrieveVariables = {
  pathParams: ApiUploadRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUploadRetrieve = (
  variables: ApiUploadRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UploadedFile,
    ApiUploadRetrieveError,
    undefined,
    {},
    {},
    ApiUploadRetrievePathParams
  >({ url: "/api/upload/{id}/", method: "get", ...variables, signal });

export const useApiUploadRetrieve = <TData = Schemas.UploadedFile,>(
  variables: ApiUploadRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UploadedFile,
      ApiUploadRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.UploadedFile,
    ApiUploadRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/upload/{id}/",
      operationId: "apiUploadRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUploadRetrieve({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiUploadDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUploadDestroyError = Fetcher.ErrorWrapper<undefined>;

export type ApiUploadDestroyVariables = {
  pathParams: ApiUploadDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUploadDestroy = (
  variables: ApiUploadDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiUploadDestroyError,
    undefined,
    {},
    {},
    ApiUploadDestroyPathParams
  >({ url: "/api/upload/{id}/", method: "delete", ...variables, signal });

export const useApiUploadDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUploadDestroyError,
      ApiUploadDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiUploadDestroyError,
    ApiUploadDestroyVariables
  >({
    mutationFn: (variables: ApiUploadDestroyVariables) =>
      fetchApiUploadDestroy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUploadUploadQuestionFileCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUploadUploadQuestionFileCreateVariables = {
  body: Schemas.UploadedFileRequest;
} & LctApIContext["fetcherOptions"];

export const fetchApiUploadUploadQuestionFileCreate = (
  variables: ApiUploadUploadQuestionFileCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UploadedFile,
    ApiUploadUploadQuestionFileCreateError,
    Schemas.UploadedFileRequest,
    {},
    {},
    {}
  >({
    url: "/api/upload/upload-question-file/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUploadUploadQuestionFileCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UploadedFile,
      ApiUploadUploadQuestionFileCreateError,
      ApiUploadUploadQuestionFileCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UploadedFile,
    ApiUploadUploadQuestionFileCreateError,
    ApiUploadUploadQuestionFileCreateVariables
  >({
    mutationFn: (variables: ApiUploadUploadQuestionFileCreateVariables) =>
      fetchApiUploadUploadQuestionFileCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsListQueryParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * A search term.
   */
  search?: string;
  /**
   * * `STARTED` - Started
   * * `PART_1_SUBMITTED` - Part 1 Submitted
   * * `PART_1_APPROVED` - Part 1 Approved
   * * `PART_2_SUBMITTED` - Part 2 Submitted
   * * `REJECTED` - Rejected
   * * `APPROVED` - Application Approved
   * * `FURTHER_INFO_PART_1` - Further Information Required (Part 1)
   * * `FURTHER_INFO_PART_2` - Further Information Required (Part 2)
   */
  status?:
    | "APPROVED"
    | "FURTHER_INFO_PART_1"
    | "FURTHER_INFO_PART_2"
    | "PART_1_APPROVED"
    | "PART_1_SUBMITTED"
    | "PART_2_SUBMITTED"
    | "REJECTED"
    | "STARTED";
  user?: number;
};

export type ApiUserApplicationsListError = Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsListVariables = {
  queryParams?: ApiUserApplicationsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsList = (
  variables: ApiUserApplicationsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedUserApplicationList,
    ApiUserApplicationsListError,
    undefined,
    {},
    ApiUserApplicationsListQueryParams,
    {}
  >({ url: "/api/user-applications/", method: "get", ...variables, signal });

export const useApiUserApplicationsList = <
  TData = Schemas.PaginatedUserApplicationList,
>(
  variables: ApiUserApplicationsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedUserApplicationList,
      ApiUserApplicationsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedUserApplicationList,
    ApiUserApplicationsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/user-applications/",
      operationId: "apiUserApplicationsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUserApplicationsList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ApiUserApplicationsCreateError = Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsCreateVariables = {
  body: Schemas.UserApplicationCreateRequest;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsCreate = (
  variables: ApiUserApplicationsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationCreate,
    ApiUserApplicationsCreateError,
    Schemas.UserApplicationCreateRequest,
    {},
    {},
    {}
  >({ url: "/api/user-applications/", method: "post", ...variables, signal });

export const useApiUserApplicationsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplicationCreate,
      ApiUserApplicationsCreateError,
      ApiUserApplicationsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplicationCreate,
    ApiUserApplicationsCreateError,
    ApiUserApplicationsCreateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsCreateVariables) =>
      fetchApiUserApplicationsCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUserApplicationsRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsRetrieveError = Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsRetrieveVariables = {
  pathParams: ApiUserApplicationsRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsRetrieve = (
  variables: ApiUserApplicationsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiUserApplicationsRetrieveError,
    undefined,
    {},
    {},
    ApiUserApplicationsRetrievePathParams
  >({
    url: "/api/user-applications/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiUserApplicationsRetrieve = <
  TData = Schemas.UserApplication,
>(
  variables: ApiUserApplicationsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserApplication,
      ApiUserApplicationsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.UserApplication,
    ApiUserApplicationsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/user-applications/{id}/",
      operationId: "apiUserApplicationsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUserApplicationsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiUserApplicationsUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsUpdateError = Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsUpdateVariables = {
  body?: Schemas.UserApplicationRequest;
  pathParams: ApiUserApplicationsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsUpdate = (
  variables: ApiUserApplicationsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiUserApplicationsUpdateError,
    Schemas.UserApplicationRequest,
    {},
    {},
    ApiUserApplicationsUpdatePathParams
  >({
    url: "/api/user-applications/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiUserApplicationsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplication,
      ApiUserApplicationsUpdateError,
      ApiUserApplicationsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplication,
    ApiUserApplicationsUpdateError,
    ApiUserApplicationsUpdateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsUpdateVariables) =>
      fetchApiUserApplicationsUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUserApplicationsPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsPartialUpdateVariables = {
  body?: Schemas.PatchedUserApplicationRequest;
  pathParams: ApiUserApplicationsPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsPartialUpdate = (
  variables: ApiUserApplicationsPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiUserApplicationsPartialUpdateError,
    Schemas.PatchedUserApplicationRequest,
    {},
    {},
    ApiUserApplicationsPartialUpdatePathParams
  >({
    url: "/api/user-applications/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiUserApplicationsPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplication,
      ApiUserApplicationsPartialUpdateError,
      ApiUserApplicationsPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplication,
    ApiUserApplicationsPartialUpdateError,
    ApiUserApplicationsPartialUpdateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsPartialUpdateVariables) =>
      fetchApiUserApplicationsPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsDestroyError = Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsDestroyVariables = {
  pathParams: ApiUserApplicationsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsDestroy = (
  variables: ApiUserApplicationsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiUserApplicationsDestroyError,
    undefined,
    {},
    {},
    ApiUserApplicationsDestroyPathParams
  >({
    url: "/api/user-applications/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiUserApplicationsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUserApplicationsDestroyError,
      ApiUserApplicationsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiUserApplicationsDestroyError,
    ApiUserApplicationsDestroyVariables
  >({
    mutationFn: (variables: ApiUserApplicationsDestroyVariables) =>
      fetchApiUserApplicationsDestroy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUserApplicationsAnswersListPathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsAnswersListQueryParams = {
  /**
   * @format uuid
   */
  application_question?: string;
};

export type ApiUserApplicationsAnswersListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsAnswersListResponse =
  Schemas.ApplicationAnswerDetail[];

export type ApiUserApplicationsAnswersListVariables = {
  pathParams: ApiUserApplicationsAnswersListPathParams;
  queryParams?: ApiUserApplicationsAnswersListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsAnswersList = (
  variables: ApiUserApplicationsAnswersListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    ApiUserApplicationsAnswersListResponse,
    ApiUserApplicationsAnswersListError,
    undefined,
    {},
    ApiUserApplicationsAnswersListQueryParams,
    ApiUserApplicationsAnswersListPathParams
  >({
    url: "/api/user-applications/{id}/answers/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiUserApplicationsAnswersList = <
  TData = ApiUserApplicationsAnswersListResponse,
>(
  variables: ApiUserApplicationsAnswersListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiUserApplicationsAnswersListResponse,
      ApiUserApplicationsAnswersListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    ApiUserApplicationsAnswersListResponse,
    ApiUserApplicationsAnswersListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/user-applications/{id}/answers/",
      operationId: "apiUserApplicationsAnswersList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUserApplicationsAnswersList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiUserApplicationsAnswersCreatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsAnswersCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsAnswersCreateVariables = {
  body: Schemas.ApplicationAnswerDetailRequest;
  pathParams: ApiUserApplicationsAnswersCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsAnswersCreate = (
  variables: ApiUserApplicationsAnswersCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersCreateError,
    Schemas.ApplicationAnswerDetailRequest,
    {},
    {},
    ApiUserApplicationsAnswersCreatePathParams
  >({
    url: "/api/user-applications/{id}/answers/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUserApplicationsAnswersCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerDetail,
      ApiUserApplicationsAnswersCreateError,
      ApiUserApplicationsAnswersCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersCreateError,
    ApiUserApplicationsAnswersCreateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsAnswersCreateVariables) =>
      fetchApiUserApplicationsAnswersCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsApproveCreatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsApproveCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsApproveCreateVariables = {
  pathParams: ApiUserApplicationsApproveCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsApproveCreate = (
  variables: ApiUserApplicationsApproveCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplication,
    ApiUserApplicationsApproveCreateError,
    undefined,
    {},
    {},
    ApiUserApplicationsApproveCreatePathParams
  >({
    url: "/api/user-applications/{id}/approve/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUserApplicationsApproveCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplication,
      ApiUserApplicationsApproveCreateError,
      ApiUserApplicationsApproveCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplication,
    ApiUserApplicationsApproveCreateError,
    ApiUserApplicationsApproveCreateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsApproveCreateVariables) =>
      fetchApiUserApplicationsApproveCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsBulkSaveCreatePathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiUserApplicationsBulkSaveCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsBulkSaveCreateVariables = {
  body: Schemas.ApplicationAnswerBulkCreateRequest;
  pathParams: ApiUserApplicationsBulkSaveCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsBulkSaveCreate = (
  variables: ApiUserApplicationsBulkSaveCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerBulkCreate,
    ApiUserApplicationsBulkSaveCreateError,
    Schemas.ApplicationAnswerBulkCreateRequest,
    {},
    {},
    ApiUserApplicationsBulkSaveCreatePathParams
  >({
    url: "/api/user-applications/{id}/bulk-save",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUserApplicationsBulkSaveCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerBulkCreate,
      ApiUserApplicationsBulkSaveCreateError,
      ApiUserApplicationsBulkSaveCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerBulkCreate,
    ApiUserApplicationsBulkSaveCreateError,
    ApiUserApplicationsBulkSaveCreateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsBulkSaveCreateVariables) =>
      fetchApiUserApplicationsBulkSaveCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsAnswersRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsAnswersRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsAnswersRetrieveVariables = {
  pathParams: ApiUserApplicationsAnswersRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsAnswersRetrieve = (
  variables: ApiUserApplicationsAnswersRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersRetrieveError,
    undefined,
    {},
    {},
    ApiUserApplicationsAnswersRetrievePathParams
  >({
    url: "/api/user-applications/{userapp}/answers/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiUserApplicationsAnswersRetrieve = <
  TData = Schemas.ApplicationAnswerDetail,
>(
  variables: ApiUserApplicationsAnswersRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ApplicationAnswerDetail,
      ApiUserApplicationsAnswersRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/user-applications/{userapp}/answers/{id}/",
      operationId: "apiUserApplicationsAnswersRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUserApplicationsAnswersRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiUserApplicationsAnswersUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsAnswersUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsAnswersUpdateVariables = {
  body: Schemas.ApplicationAnswerDetailRequest;
  pathParams: ApiUserApplicationsAnswersUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsAnswersUpdate = (
  variables: ApiUserApplicationsAnswersUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersUpdateError,
    Schemas.ApplicationAnswerDetailRequest,
    {},
    {},
    ApiUserApplicationsAnswersUpdatePathParams
  >({
    url: "/api/user-applications/{userapp}/answers/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiUserApplicationsAnswersUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerDetail,
      ApiUserApplicationsAnswersUpdateError,
      ApiUserApplicationsAnswersUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersUpdateError,
    ApiUserApplicationsAnswersUpdateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsAnswersUpdateVariables) =>
      fetchApiUserApplicationsAnswersUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsAnswersPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsAnswersPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsAnswersPartialUpdateVariables = {
  body?: Schemas.PatchedApplicationAnswerDetailRequest;
  pathParams: ApiUserApplicationsAnswersPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsAnswersPartialUpdate = (
  variables: ApiUserApplicationsAnswersPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersPartialUpdateError,
    Schemas.PatchedApplicationAnswerDetailRequest,
    {},
    {},
    ApiUserApplicationsAnswersPartialUpdatePathParams
  >({
    url: "/api/user-applications/{userapp}/answers/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiUserApplicationsAnswersPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApplicationAnswerDetail,
      ApiUserApplicationsAnswersPartialUpdateError,
      ApiUserApplicationsAnswersPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.ApplicationAnswerDetail,
    ApiUserApplicationsAnswersPartialUpdateError,
    ApiUserApplicationsAnswersPartialUpdateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsAnswersPartialUpdateVariables) =>
      fetchApiUserApplicationsAnswersPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsAnswersDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsAnswersDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsAnswersDestroyVariables = {
  pathParams: ApiUserApplicationsAnswersDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsAnswersDestroy = (
  variables: ApiUserApplicationsAnswersDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiUserApplicationsAnswersDestroyError,
    undefined,
    {},
    {},
    ApiUserApplicationsAnswersDestroyPathParams
  >({
    url: "/api/user-applications/{userapp}/answers/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiUserApplicationsAnswersDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUserApplicationsAnswersDestroyError,
      ApiUserApplicationsAnswersDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiUserApplicationsAnswersDestroyError,
    ApiUserApplicationsAnswersDestroyVariables
  >({
    mutationFn: (variables: ApiUserApplicationsAnswersDestroyVariables) =>
      fetchApiUserApplicationsAnswersDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsCommentsListPathParams = {
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsCommentsListQueryParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ApiUserApplicationsCommentsListError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsCommentsListVariables = {
  pathParams: ApiUserApplicationsCommentsListPathParams;
  queryParams?: ApiUserApplicationsCommentsListQueryParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsCommentsList = (
  variables: ApiUserApplicationsCommentsListVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.PaginatedUserApplicationCommentList,
    ApiUserApplicationsCommentsListError,
    undefined,
    {},
    ApiUserApplicationsCommentsListQueryParams,
    ApiUserApplicationsCommentsListPathParams
  >({
    url: "/api/user-applications/{userapp}/comments/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiUserApplicationsCommentsList = <
  TData = Schemas.PaginatedUserApplicationCommentList,
>(
  variables: ApiUserApplicationsCommentsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedUserApplicationCommentList,
      ApiUserApplicationsCommentsListError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.PaginatedUserApplicationCommentList,
    ApiUserApplicationsCommentsListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/user-applications/{userapp}/comments/",
      operationId: "apiUserApplicationsCommentsList",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUserApplicationsCommentsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiUserApplicationsCommentsCreatePathParams = {
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsCommentsCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsCommentsCreateVariables = {
  body: Schemas.UserApplicationCommentRequest;
  pathParams: ApiUserApplicationsCommentsCreatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsCommentsCreate = (
  variables: ApiUserApplicationsCommentsCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsCreateError,
    Schemas.UserApplicationCommentRequest,
    {},
    {},
    ApiUserApplicationsCommentsCreatePathParams
  >({
    url: "/api/user-applications/{userapp}/comments/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUserApplicationsCommentsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplicationComment,
      ApiUserApplicationsCommentsCreateError,
      ApiUserApplicationsCommentsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsCreateError,
    ApiUserApplicationsCommentsCreateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsCommentsCreateVariables) =>
      fetchApiUserApplicationsCommentsCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsCommentsRetrievePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsCommentsRetrieveError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsCommentsRetrieveVariables = {
  pathParams: ApiUserApplicationsCommentsRetrievePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsCommentsRetrieve = (
  variables: ApiUserApplicationsCommentsRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsRetrieveError,
    undefined,
    {},
    {},
    ApiUserApplicationsCommentsRetrievePathParams
  >({
    url: "/api/user-applications/{userapp}/comments/{id}/",
    method: "get",
    ...variables,
    signal,
  });

export const useApiUserApplicationsCommentsRetrieve = <
  TData = Schemas.UserApplicationComment,
>(
  variables: ApiUserApplicationsCommentsRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserApplicationComment,
      ApiUserApplicationsCommentsRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsRetrieveError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/api/user-applications/{userapp}/comments/{id}/",
      operationId: "apiUserApplicationsCommentsRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiUserApplicationsCommentsRetrieve(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type ApiUserApplicationsCommentsUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsCommentsUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsCommentsUpdateVariables = {
  body: Schemas.UserApplicationCommentRequest;
  pathParams: ApiUserApplicationsCommentsUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsCommentsUpdate = (
  variables: ApiUserApplicationsCommentsUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsUpdateError,
    Schemas.UserApplicationCommentRequest,
    {},
    {},
    ApiUserApplicationsCommentsUpdatePathParams
  >({
    url: "/api/user-applications/{userapp}/comments/{id}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiUserApplicationsCommentsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplicationComment,
      ApiUserApplicationsCommentsUpdateError,
      ApiUserApplicationsCommentsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsUpdateError,
    ApiUserApplicationsCommentsUpdateVariables
  >({
    mutationFn: (variables: ApiUserApplicationsCommentsUpdateVariables) =>
      fetchApiUserApplicationsCommentsUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsCommentsPartialUpdatePathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsCommentsPartialUpdateError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsCommentsPartialUpdateVariables = {
  body?: Schemas.PatchedUserApplicationCommentRequest;
  pathParams: ApiUserApplicationsCommentsPartialUpdatePathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsCommentsPartialUpdate = (
  variables: ApiUserApplicationsCommentsPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsPartialUpdateError,
    Schemas.PatchedUserApplicationCommentRequest,
    {},
    {},
    ApiUserApplicationsCommentsPartialUpdatePathParams
  >({
    url: "/api/user-applications/{userapp}/comments/{id}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiUserApplicationsCommentsPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserApplicationComment,
      ApiUserApplicationsCommentsPartialUpdateError,
      ApiUserApplicationsCommentsPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.UserApplicationComment,
    ApiUserApplicationsCommentsPartialUpdateError,
    ApiUserApplicationsCommentsPartialUpdateVariables
  >({
    mutationFn: (
      variables: ApiUserApplicationsCommentsPartialUpdateVariables,
    ) =>
      fetchApiUserApplicationsCommentsPartialUpdate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUserApplicationsCommentsDestroyPathParams = {
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userapp: string;
};

export type ApiUserApplicationsCommentsDestroyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUserApplicationsCommentsDestroyVariables = {
  pathParams: ApiUserApplicationsCommentsDestroyPathParams;
} & LctApIContext["fetcherOptions"];

export const fetchApiUserApplicationsCommentsDestroy = (
  variables: ApiUserApplicationsCommentsDestroyVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    undefined,
    ApiUserApplicationsCommentsDestroyError,
    undefined,
    {},
    {},
    ApiUserApplicationsCommentsDestroyPathParams
  >({
    url: "/api/user-applications/{userapp}/comments/{id}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiUserApplicationsCommentsDestroy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUserApplicationsCommentsDestroyError,
      ApiUserApplicationsCommentsDestroyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    undefined,
    ApiUserApplicationsCommentsDestroyError,
    ApiUserApplicationsCommentsDestroyVariables
  >({
    mutationFn: (variables: ApiUserApplicationsCommentsDestroyVariables) =>
      fetchApiUserApplicationsCommentsDestroy({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type DjRestAuthLoginCreateError = Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthLoginCreateVariables = {
  body: Schemas.LoginRequest;
} & LctApIContext["fetcherOptions"];

/**
 * Check the credentials and return the REST Token
 * if the credentials are valid and authenticated.
 * Calls Django Auth login method to register User ID
 * in Django session framework
 *
 * Accept the following POST parameters: username, password
 * Return the REST Framework Token Object's key.
 */
export const fetchDjRestAuthLoginCreate = (
  variables: DjRestAuthLoginCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Token,
    DjRestAuthLoginCreateError,
    Schemas.LoginRequest,
    {},
    {},
    {}
  >({ url: "/dj-rest-auth/login/", method: "post", ...variables, signal });

/**
 * Check the credentials and return the REST Token
 * if the credentials are valid and authenticated.
 * Calls Django Auth login method to register User ID
 * in Django session framework
 *
 * Accept the following POST parameters: username, password
 * Return the REST Framework Token Object's key.
 */
export const useDjRestAuthLoginCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Token,
      DjRestAuthLoginCreateError,
      DjRestAuthLoginCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Token,
    DjRestAuthLoginCreateError,
    DjRestAuthLoginCreateVariables
  >({
    mutationFn: (variables: DjRestAuthLoginCreateVariables) =>
      fetchDjRestAuthLoginCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DjRestAuthLogoutCreateError = Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthLogoutCreateVariables = LctApIContext["fetcherOptions"];

/**
 * Calls Django logout method and delete the Token object
 * assigned to the current User object.
 *
 * Accepts/Returns nothing.
 */
export const fetchDjRestAuthLogoutCreate = (
  variables: DjRestAuthLogoutCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.RestAuthDetail,
    DjRestAuthLogoutCreateError,
    undefined,
    {},
    {},
    {}
  >({ url: "/dj-rest-auth/logout/", method: "post", ...variables, signal });

/**
 * Calls Django logout method and delete the Token object
 * assigned to the current User object.
 *
 * Accepts/Returns nothing.
 */
export const useDjRestAuthLogoutCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RestAuthDetail,
      DjRestAuthLogoutCreateError,
      DjRestAuthLogoutCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.RestAuthDetail,
    DjRestAuthLogoutCreateError,
    DjRestAuthLogoutCreateVariables
  >({
    mutationFn: (variables: DjRestAuthLogoutCreateVariables) =>
      fetchDjRestAuthLogoutCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DjRestAuthPasswordChangeCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthPasswordChangeCreateVariables = {
  body: Schemas.PasswordChangeRequest;
} & LctApIContext["fetcherOptions"];

/**
 * Calls Django Auth SetPasswordForm save method.
 *
 * Accepts the following POST parameters: new_password1, new_password2
 * Returns the success/fail message.
 */
export const fetchDjRestAuthPasswordChangeCreate = (
  variables: DjRestAuthPasswordChangeCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.RestAuthDetail,
    DjRestAuthPasswordChangeCreateError,
    Schemas.PasswordChangeRequest,
    {},
    {},
    {}
  >({
    url: "/dj-rest-auth/password/change/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Calls Django Auth SetPasswordForm save method.
 *
 * Accepts the following POST parameters: new_password1, new_password2
 * Returns the success/fail message.
 */
export const useDjRestAuthPasswordChangeCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RestAuthDetail,
      DjRestAuthPasswordChangeCreateError,
      DjRestAuthPasswordChangeCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.RestAuthDetail,
    DjRestAuthPasswordChangeCreateError,
    DjRestAuthPasswordChangeCreateVariables
  >({
    mutationFn: (variables: DjRestAuthPasswordChangeCreateVariables) =>
      fetchDjRestAuthPasswordChangeCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DjRestAuthPasswordResetCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthPasswordResetCreateVariables = {
  body: Schemas.CustomPasswordResetRequest;
} & LctApIContext["fetcherOptions"];

/**
 * Calls Django Auth PasswordResetForm save method.
 *
 * Accepts the following POST parameters: email
 * Returns the success/fail message.
 */
export const fetchDjRestAuthPasswordResetCreate = (
  variables: DjRestAuthPasswordResetCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.RestAuthDetail,
    DjRestAuthPasswordResetCreateError,
    Schemas.CustomPasswordResetRequest,
    {},
    {},
    {}
  >({
    url: "/dj-rest-auth/password/reset/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Calls Django Auth PasswordResetForm save method.
 *
 * Accepts the following POST parameters: email
 * Returns the success/fail message.
 */
export const useDjRestAuthPasswordResetCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RestAuthDetail,
      DjRestAuthPasswordResetCreateError,
      DjRestAuthPasswordResetCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.RestAuthDetail,
    DjRestAuthPasswordResetCreateError,
    DjRestAuthPasswordResetCreateVariables
  >({
    mutationFn: (variables: DjRestAuthPasswordResetCreateVariables) =>
      fetchDjRestAuthPasswordResetCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DjRestAuthPasswordResetConfirmCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthPasswordResetConfirmCreateVariables = {
  body: Schemas.CustomPasswordResetConfirmRequest;
} & LctApIContext["fetcherOptions"];

/**
 * Password reset e-mail link is confirmed, therefore
 * this resets the user's password.
 *
 * Accepts the following POST parameters: token, uid,
 *     new_password1, new_password2
 * Returns the success/fail message.
 */
export const fetchDjRestAuthPasswordResetConfirmCreate = (
  variables: DjRestAuthPasswordResetConfirmCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.RestAuthDetail,
    DjRestAuthPasswordResetConfirmCreateError,
    Schemas.CustomPasswordResetConfirmRequest,
    {},
    {},
    {}
  >({
    url: "/dj-rest-auth/password/reset/confirm/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Password reset e-mail link is confirmed, therefore
 * this resets the user's password.
 *
 * Accepts the following POST parameters: token, uid,
 *     new_password1, new_password2
 * Returns the success/fail message.
 */
export const useDjRestAuthPasswordResetConfirmCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RestAuthDetail,
      DjRestAuthPasswordResetConfirmCreateError,
      DjRestAuthPasswordResetConfirmCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.RestAuthDetail,
    DjRestAuthPasswordResetConfirmCreateError,
    DjRestAuthPasswordResetConfirmCreateVariables
  >({
    mutationFn: (variables: DjRestAuthPasswordResetConfirmCreateVariables) =>
      fetchDjRestAuthPasswordResetConfirmCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type DjRestAuthRegistrationCreateError = Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthRegistrationCreateVariables = {
  body: Schemas.CustomRegisterRequest;
} & LctApIContext["fetcherOptions"];

export const fetchDjRestAuthRegistrationCreate = (
  variables: DjRestAuthRegistrationCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.Token,
    DjRestAuthRegistrationCreateError,
    Schemas.CustomRegisterRequest,
    {},
    {},
    {}
  >({
    url: "/dj-rest-auth/registration/",
    method: "post",
    ...variables,
    signal,
  });

export const useDjRestAuthRegistrationCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Token,
      DjRestAuthRegistrationCreateError,
      DjRestAuthRegistrationCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.Token,
    DjRestAuthRegistrationCreateError,
    DjRestAuthRegistrationCreateVariables
  >({
    mutationFn: (variables: DjRestAuthRegistrationCreateVariables) =>
      fetchDjRestAuthRegistrationCreate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DjRestAuthRegistrationResendEmailCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthRegistrationResendEmailCreateVariables = {
  body: Schemas.ResendEmailVerificationRequest;
} & LctApIContext["fetcherOptions"];

export const fetchDjRestAuthRegistrationResendEmailCreate = (
  variables: DjRestAuthRegistrationResendEmailCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.RestAuthDetail,
    DjRestAuthRegistrationResendEmailCreateError,
    Schemas.ResendEmailVerificationRequest,
    {},
    {},
    {}
  >({
    url: "/dj-rest-auth/registration/resend-email/",
    method: "post",
    ...variables,
    signal,
  });

export const useDjRestAuthRegistrationResendEmailCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RestAuthDetail,
      DjRestAuthRegistrationResendEmailCreateError,
      DjRestAuthRegistrationResendEmailCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.RestAuthDetail,
    DjRestAuthRegistrationResendEmailCreateError,
    DjRestAuthRegistrationResendEmailCreateVariables
  >({
    mutationFn: (variables: DjRestAuthRegistrationResendEmailCreateVariables) =>
      fetchDjRestAuthRegistrationResendEmailCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type DjRestAuthRegistrationVerifyEmailCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthRegistrationVerifyEmailCreateVariables = {
  body: Schemas.VerifyEmailRequest;
} & LctApIContext["fetcherOptions"];

export const fetchDjRestAuthRegistrationVerifyEmailCreate = (
  variables: DjRestAuthRegistrationVerifyEmailCreateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.RestAuthDetail,
    DjRestAuthRegistrationVerifyEmailCreateError,
    Schemas.VerifyEmailRequest,
    {},
    {},
    {}
  >({
    url: "/dj-rest-auth/registration/verify-email/",
    method: "post",
    ...variables,
    signal,
  });

export const useDjRestAuthRegistrationVerifyEmailCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RestAuthDetail,
      DjRestAuthRegistrationVerifyEmailCreateError,
      DjRestAuthRegistrationVerifyEmailCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.RestAuthDetail,
    DjRestAuthRegistrationVerifyEmailCreateError,
    DjRestAuthRegistrationVerifyEmailCreateVariables
  >({
    mutationFn: (variables: DjRestAuthRegistrationVerifyEmailCreateVariables) =>
      fetchDjRestAuthRegistrationVerifyEmailCreate({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type DjRestAuthUserRetrieveError = Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthUserRetrieveVariables = LctApIContext["fetcherOptions"];

/**
 * Reads and updates UserModel fields
 * Accepts GET, PUT, PATCH methods.
 *
 * Default accepted fields: username, first_name, last_name
 * Default display fields: pk, username, email, first_name, last_name
 * Read-only fields: pk, email
 *
 * Returns UserModel fields.
 */
export const fetchDjRestAuthUserRetrieve = (
  variables: DjRestAuthUserRetrieveVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<Schemas.User, DjRestAuthUserRetrieveError, undefined, {}, {}, {}>(
    { url: "/dj-rest-auth/user/", method: "get", ...variables, signal },
  );

/**
 * Reads and updates UserModel fields
 * Accepts GET, PUT, PATCH methods.
 *
 * Default accepted fields: username, first_name, last_name
 * Default display fields: pk, username, email, first_name, last_name
 * Read-only fields: pk, email
 *
 * Returns UserModel fields.
 */
export const useDjRestAuthUserRetrieve = <TData = Schemas.User,>(
  variables: DjRestAuthUserRetrieveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.User,
      DjRestAuthUserRetrieveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useLctApIContext(options);
  return reactQuery.useQuery<Schemas.User, DjRestAuthUserRetrieveError, TData>({
    queryKey: queryKeyFn({
      path: "/dj-rest-auth/user/",
      operationId: "djRestAuthUserRetrieve",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchDjRestAuthUserRetrieve({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DjRestAuthUserUpdateError = Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthUserUpdateVariables = {
  body: Schemas.UserRequest;
} & LctApIContext["fetcherOptions"];

/**
 * Reads and updates UserModel fields
 * Accepts GET, PUT, PATCH methods.
 *
 * Default accepted fields: username, first_name, last_name
 * Default display fields: pk, username, email, first_name, last_name
 * Read-only fields: pk, email
 *
 * Returns UserModel fields.
 */
export const fetchDjRestAuthUserUpdate = (
  variables: DjRestAuthUserUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.User,
    DjRestAuthUserUpdateError,
    Schemas.UserRequest,
    {},
    {},
    {}
  >({ url: "/dj-rest-auth/user/", method: "put", ...variables, signal });

/**
 * Reads and updates UserModel fields
 * Accepts GET, PUT, PATCH methods.
 *
 * Default accepted fields: username, first_name, last_name
 * Default display fields: pk, username, email, first_name, last_name
 * Read-only fields: pk, email
 *
 * Returns UserModel fields.
 */
export const useDjRestAuthUserUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.User,
      DjRestAuthUserUpdateError,
      DjRestAuthUserUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.User,
    DjRestAuthUserUpdateError,
    DjRestAuthUserUpdateVariables
  >({
    mutationFn: (variables: DjRestAuthUserUpdateVariables) =>
      fetchDjRestAuthUserUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DjRestAuthUserPartialUpdateError = Fetcher.ErrorWrapper<undefined>;

export type DjRestAuthUserPartialUpdateVariables = {
  body?: Schemas.PatchedUserRequest;
} & LctApIContext["fetcherOptions"];

/**
 * Reads and updates UserModel fields
 * Accepts GET, PUT, PATCH methods.
 *
 * Default accepted fields: username, first_name, last_name
 * Default display fields: pk, username, email, first_name, last_name
 * Read-only fields: pk, email
 *
 * Returns UserModel fields.
 */
export const fetchDjRestAuthUserPartialUpdate = (
  variables: DjRestAuthUserPartialUpdateVariables,
  signal?: AbortSignal,
) =>
  lctApIFetch<
    Schemas.User,
    DjRestAuthUserPartialUpdateError,
    Schemas.PatchedUserRequest,
    {},
    {},
    {}
  >({ url: "/dj-rest-auth/user/", method: "patch", ...variables, signal });

/**
 * Reads and updates UserModel fields
 * Accepts GET, PUT, PATCH methods.
 *
 * Default accepted fields: username, first_name, last_name
 * Default display fields: pk, username, email, first_name, last_name
 * Read-only fields: pk, email
 *
 * Returns UserModel fields.
 */
export const useDjRestAuthUserPartialUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.User,
      DjRestAuthUserPartialUpdateError,
      DjRestAuthUserPartialUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useLctApIContext();
  return reactQuery.useMutation<
    Schemas.User,
    DjRestAuthUserPartialUpdateError,
    DjRestAuthUserPartialUpdateVariables
  >({
    mutationFn: (variables: DjRestAuthUserPartialUpdateVariables) =>
      fetchDjRestAuthUserPartialUpdate({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type QueryOperation =
  | {
      path: "/api/accounts/users/";
      operationId: "apiAccountsUsersList";
      variables: ApiAccountsUsersListVariables;
    }
  | {
      path: "/api/accounts/users/{id}/";
      operationId: "apiAccountsUsersRetrieve";
      variables: ApiAccountsUsersRetrieveVariables;
    }
  | {
      path: "/api/accounts/users/{user}/profile/edit";
      operationId: "apiAccountsUsersProfileEditRetrieve";
      variables: ApiAccountsUsersProfileEditRetrieveVariables;
    }
  | {
      path: "/api/all-user-applications/";
      operationId: "apiAllUserApplicationsList";
      variables: ApiAllUserApplicationsListVariables;
    }
  | {
      path: "/api/carbon-scores/";
      operationId: "apiCarbonScoresList";
      variables: ApiCarbonScoresListVariables;
    }
  | {
      path: "/api/integrations/carbon-calculator/pathways/";
      operationId: "apiIntegrationsCarbonCalculatorPathwaysList";
      variables: ApiIntegrationsCarbonCalculatorPathwaysListVariables;
    }
  | {
      path: "/api/integrations/carbon-calculator/pathways/{id}/";
      operationId: "apiIntegrationsCarbonCalculatorPathwaysRetrieve";
      variables: ApiIntegrationsCarbonCalculatorPathwaysRetrieveVariables;
    }
  | {
      path: "/api/integrations/carbon-calculator/variable-questions/";
      operationId: "apiIntegrationsCarbonCalculatorVariableQuestionsList";
      variables: ApiIntegrationsCarbonCalculatorVariableQuestionsListVariables;
    }
  | {
      path: "/api/integrations/carbon-calculator/variable-questions/{id}/";
      operationId: "apiIntegrationsCarbonCalculatorVariableQuestionsRetrieve";
      variables: ApiIntegrationsCarbonCalculatorVariableQuestionsRetrieveVariables;
    }
  | {
      path: "/api/integrations/carbon-calculator/variables/";
      operationId: "apiIntegrationsCarbonCalculatorVariablesList";
      variables: ApiIntegrationsCarbonCalculatorVariablesListVariables;
    }
  | {
      path: "/api/integrations/carbon-calculator/variables/{id}/";
      operationId: "apiIntegrationsCarbonCalculatorVariablesRetrieve";
      variables: ApiIntegrationsCarbonCalculatorVariablesRetrieveVariables;
    }
  | {
      path: "/api/pvp/";
      operationId: "apiPvpList";
      variables: ApiPvpListVariables;
    }
  | {
      path: "/api/pvp/{id}/";
      operationId: "apiPvpRetrieve";
      variables: ApiPvpRetrieveVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/";
      operationId: "apiPvpApplicationsList";
      variables: ApiPvpApplicationsListVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/sections/";
      operationId: "apiPvpApplicationsSectionsList";
      variables: ApiPvpApplicationsSectionsListVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/sections/{id}/";
      operationId: "apiPvpApplicationsSectionsRetrieve";
      variables: ApiPvpApplicationsSectionsRetrieveVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/";
      operationId: "apiPvpApplicationsSectionsQuestionsList";
      variables: ApiPvpApplicationsSectionsQuestionsListVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/sections/{section}/questions/{id}/";
      operationId: "apiPvpApplicationsSectionsQuestionsRetrieve";
      variables: ApiPvpApplicationsSectionsQuestionsRetrieveVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/";
      operationId: "apiPvpApplicationsUserApplicationsList";
      variables: ApiPvpApplicationsUserApplicationsListVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/";
      operationId: "apiPvpApplicationsUserApplicationsRetrieve";
      variables: ApiPvpApplicationsUserApplicationsRetrieveVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{id}/answers/";
      operationId: "apiPvpApplicationsUserApplicationsAnswersList";
      variables: ApiPvpApplicationsUserApplicationsAnswersListVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/answers/{id}/";
      operationId: "apiPvpApplicationsUserApplicationsAnswersRetrieve";
      variables: ApiPvpApplicationsUserApplicationsAnswersRetrieveVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/";
      operationId: "apiPvpApplicationsUserApplicationsCommentsList";
      variables: ApiPvpApplicationsUserApplicationsCommentsListVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{app}/user-applications/{userapp}/comments/{id}/";
      operationId: "apiPvpApplicationsUserApplicationsCommentsRetrieve";
      variables: ApiPvpApplicationsUserApplicationsCommentsRetrieveVariables;
    }
  | {
      path: "/api/pvp/{pvp}/applications/{id}/";
      operationId: "apiPvpApplicationsRetrieve";
      variables: ApiPvpApplicationsRetrieveVariables;
    }
  | {
      path: "/api/upload/";
      operationId: "apiUploadList";
      variables: ApiUploadListVariables;
    }
  | {
      path: "/api/upload/{id}/";
      operationId: "apiUploadRetrieve";
      variables: ApiUploadRetrieveVariables;
    }
  | {
      path: "/api/user-applications/";
      operationId: "apiUserApplicationsList";
      variables: ApiUserApplicationsListVariables;
    }
  | {
      path: "/api/user-applications/{id}/";
      operationId: "apiUserApplicationsRetrieve";
      variables: ApiUserApplicationsRetrieveVariables;
    }
  | {
      path: "/api/user-applications/{id}/answers/";
      operationId: "apiUserApplicationsAnswersList";
      variables: ApiUserApplicationsAnswersListVariables;
    }
  | {
      path: "/api/user-applications/{userapp}/answers/{id}/";
      operationId: "apiUserApplicationsAnswersRetrieve";
      variables: ApiUserApplicationsAnswersRetrieveVariables;
    }
  | {
      path: "/api/user-applications/{userapp}/comments/";
      operationId: "apiUserApplicationsCommentsList";
      variables: ApiUserApplicationsCommentsListVariables;
    }
  | {
      path: "/api/user-applications/{userapp}/comments/{id}/";
      operationId: "apiUserApplicationsCommentsRetrieve";
      variables: ApiUserApplicationsCommentsRetrieveVariables;
    }
  | {
      path: "/dj-rest-auth/user/";
      operationId: "djRestAuthUserRetrieve";
      variables: DjRestAuthUserRetrieveVariables;
    };
